var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRegistrationDeadline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4886,
    cy: 15.4886,
    r: 15.4886,
    fill: "#D83737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.413 16.0286L14.2005 13.5643L12.1224 11.9786H14.6599L15.4911 9.42857L16.3005 11.9786H18.8599L16.7818 13.5643L17.5474 16.0286L15.4911 14.5071L13.413 16.0286ZM10.3286 24V17.4857C9.6724 16.8143 9.20209 16.0786 8.91771 15.2786C8.63334 14.4786 8.49115 13.6714 8.49115 12.8571C8.49115 10.9143 9.16198 9.28571 10.5036 7.97143C11.8453 6.65714 13.5078 6 15.4911 6C17.4745 6 19.137 6.65714 20.4787 7.97143C21.8203 9.28571 22.4911 10.9143 22.4911 12.8571C22.4911 13.6714 22.349 14.4786 22.0646 15.2786C21.7802 16.0786 21.3099 16.8143 20.6536 17.4857V24L15.4911 22.3071L10.3286 24ZM15.4911 18.4286C17.0807 18.4286 18.426 17.8893 19.5271 16.8107C20.6281 15.7321 21.1786 14.4143 21.1786 12.8571C21.1786 11.3 20.6281 9.98214 19.5271 8.90357C18.426 7.825 17.0807 7.28571 15.4911 7.28571C13.9016 7.28571 12.5563 7.825 11.4552 8.90357C10.3542 9.98214 9.80365 11.3 9.80365 12.8571C9.80365 14.4143 10.3542 15.7321 11.4552 16.8107C12.5563 17.8893 13.9016 18.4286 15.4911 18.4286ZM11.6411 22.2L15.4911 21.0214L19.3411 22.2V18.5357C18.7578 18.95 18.1307 19.25 17.4599 19.4357C16.7891 19.6214 16.1328 19.7143 15.4911 19.7143C14.8495 19.7143 14.1932 19.6214 13.5224 19.4357C12.8516 19.25 12.2245 18.95 11.6411 18.5357V22.2Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRegistrationDeadline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RegistrationDeadline.33b9f280.svg";
export { ForwardRef as ReactComponent };